module.exports = __webpack_public_path__ + "54df5c185157e74edbd87c7850646cfe.MP3";